import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleSectionCarousel"] */ "/app/src/app/_components/ArticleSections/ArticleSectionCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionWrapper"] */ "/app/src/app/_components/ArticleSections/SectionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InStream"] */ "/app/src/app/_components/common/ads/InStream.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RightRailFlex"] */ "/app/src/app/_components/common/ads/RightRailFlex.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/app/src/app/_components/common/breadcrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Icon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/iframe.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Image.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/src/app/_components/common/Pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionDescription"] */ "/app/src/app/_components/common/widgets/common/AccordionDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/src/app/_components/ui/Button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/ui/ButtonV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root"] */ "/app/src/app/_components/ui/primitives/Separator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientParser"] */ "/app/src/app/_lib/htmlParser/client.tsx");
